import GalleryItemPreviewComponent from '../../src/containers/cv-section-gallery-item/preview.vue';

export default {
  components: {
    GalleryItemPreviewComponent,
  },
};
